"use strict";

/**
 * @generated SignedSource<<20a3c62227a6c8fed62cae3a85898bf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = function () {
  var v0 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dbId",
      "storageKey": null
    },
    v1 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "useViewerAccountQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "useViewerAccountQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "cacheID": "c8b6ccf96a6d81e0c2e90926a3b5b07f",
      "id": null,
      "metadata": {},
      "name": "useViewerAccountQuery",
      "operationKind": "query",
      "text": "query useViewerAccountQuery {\n  viewer {\n    dbId\n    fullName\n    id\n  }\n}\n"
    }
  };
}();
node.hash = "7dc74885d1e59aee84f60e3de0d62cf5";
export default node;